import { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const CreateCommune = (props) => {
  const httpClient = useHttpClient(true);
  const [departements, setDepartements] = useState([]);
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();
  const [Open, setOpen] = useState(false);
  const [CreateModal, setCreateModal] = useState(false);
  const CreateModalToggle = () => resetForm();
  const Toggle = () => setOpen(!Open);
  const [spinner, setSpinner] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<any>('');
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState<any>();
  const onSubmit = async (data) => {
    const commune = { name: data['commune_name'], departement: JSON.parse(data['departement']) };
    try {
      setSpinner(true);
      const response = httpClient.current?.post(`/api/commune`, commune);
      if ((await response).status === 200) {
        setSpinner(false);
        props.communes();
        resetForm();
      }
    } catch (error) {
      console.log(error);
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    resetField('commune_name');
    resetField('departement');
    setCreateModal(!CreateModal);
  };
  useEffect(() => {
    const getCountries = () => {
      httpClient.current?.get(`/api/country/all`).then((response) => {
        setCountries(response.data);
      });
    };
    getCountries();
  }, [httpClient, selectedCountry]);
  useEffect(() => {
    const getRegions = () => {
      if (!selectedCountry) return;
      httpClient.current?.get(`/api/region/all`).then((response) => {
        let regions = response.data;
        console.log(regions);
        regions = regions.filter((region) => region.country.id === JSON.parse(selectedCountry).id);
        console.log(regions);
        console.log(selectedCountry);
        setRegions(regions);
      });
    };
    getRegions();
  }, [selectedCountry]);
  useEffect(() => {
    if (!selectedRegion) return;
    const getDepartements = () => {
      httpClient.current?.get(`/api/departement/all`).then((response) => {
        let departements = response.data;
        departements = departements.filter((departement) => departement.region.id === JSON.parse(selectedRegion).id);
        setDepartements(departements);
      });
    };
    getDepartements();
  }, [httpClient, selectedRegion]);
  return (
    <>
      <Button outline color="success" onClick={CreateModalToggle}>
        {' '}
        {props.t('create_commune')}
      </Button>
      <Modal isOpen={CreateModal} toggle={CreateModalToggle} centered>
        <ModalHeader toggle={CreateModalToggle}>{props.t('create_commune')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={Open} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="form-row">
                  <input
                    type="text"
                    className="form-control"
                    name="commune_name"
                    id="commune_name"
                    aria-invalid={errors.country_name ? 'true' : 'false'}
                    placeholder={props.t('commune_name')}
                    {...register('commune_name', { required: true })}
                  />
                  <span>{errors.commune_name && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'country_name'}>{props.t('country_name')}</label>
                  <select
                    name="country"
                    id="country"
                    className="form-control"
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                    placeholder={props.t('select_country_name')}
                  >
                    <option value="">{props.t('select_country_name')}</option>
                    {countries.map((country, index) => (
                      <option id={country.id} key={index} value={JSON.stringify(country)}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
                <FormGroup className={`form-row ${selectedCountry ? 's' : 'd-none'}`}>
                  <label htmlFor={'region_name'}>{props.t('region_name')}</label>
                  <select
                    name="region"
                    id="region"
                    className="form-control"
                    value={selectedRegion}
                    onChange={(e) => setSelectedRegion(e.target.value)}
                  >
                    <option value="">{props.t('select_region_name')}</option>

                    {regions.map((region, index) => (
                      <option id={region.id} key={index} value={JSON.stringify(region)}>
                        {region.name}
                      </option>
                    ))}
                  </select>
                  <span>{errors.region && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className={`form-row ${selectedRegion ? 's' : 'd-none'}`}>
                  <label htmlFor={'departement_name'}>{props.t('departement_name')}</label>
                  <select name="departement" id="departement" className="form-control" {...register('departement')}>
                    {departements.map((dep, index) => (
                      <option id={dep.id} key={index} value={JSON.stringify(dep)}>
                        {dep.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('save')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={resetForm}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreateCommune);
